import { render } from "./LoderInfo.vue?vue&type=template&id=0e7b45a4&scoped=true"
import script from "./LoderInfo.vue?vue&type=script&lang=js"
export * from "./LoderInfo.vue?vue&type=script&lang=js"

import "./LoderInfo.vue?vue&type=style&index=0&id=0e7b45a4&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7b45a4"]])

export default __exports__